export default __webpack_public_path__ + "assets/f17b818ee69ac9ceb18afd03ba3cf0ea.png";